import { jsxs, jsx } from 'react/jsx-runtime';
import { Fragment } from 'react';
import { ApplyHomography } from '../../components/ApplyHomography/ApplyHomography.js';
import { GroundPosition } from '../../components/GroundPosition/GroundPosition.js';
import usePlayerTracksData from '../../hooks/usePlayerTracksData.js';
import '../../utils/physicalMetrics.js';
import { getGroundPositions } from './HighlightPlayerPositions.helper.js';
import PhysicalMetrics from '../PhysicalMetrics/PhysicalMetrics.js';

const PHYSICAL_METRICS_OFFSET_Y = 50;
/**
 * `HighlightPlayerPositions` is a container designed for visualising player positions for a given play.
 *  It dynamically displays players' locations based on tracking data and the current time.
 */
function HighlightPlayerPositions({ currentTimestamp, renderComponentsNextToGroundPositions, renderComponentsOnGroundPositions, onClickPlayer = () => { }, onMouseEnterPlayer = () => { }, onMouseLeavePlayer = () => { }, playId, players, }) {
    if (!(players === null || players === void 0 ? void 0 : players.length))
        return null;
    // Not sure how this is working as I'm sure placing a hook after a return value breaks the rules of react!
    const { data } = usePlayerTracksData(playId);
    if (!data) {
        // No data to display
        return null;
    }
    const groundPositions = getGroundPositions(data, currentTimestamp, players);
    return groundPositions.map(({ colour, h, physicalMetrics, playerId, x, y, visibility }) => {
        var _a, _b;
        return (jsxs(Fragment, { children: [renderComponentsNextToGroundPositions && (
                // TO-DO: Remove as no longer needed
                jsx("foreignObject", { x: x, y: y, children: renderComponentsNextToGroundPositions({
                        player: {
                            id: playerId,
                        },
                    }) })), ((_a = physicalMetrics === null || physicalMetrics === void 0 ? void 0 : physicalMetrics.speed) === null || _a === void 0 ? void 0 : _a.active) && (jsx(PhysicalMetrics, { currentTimestamp: currentTimestamp, playerId: playerId, playId: playId, threshold: (_b = physicalMetrics === null || physicalMetrics === void 0 ? void 0 : physicalMetrics.speed) === null || _b === void 0 ? void 0 : _b.threshold, x: x, y: y + PHYSICAL_METRICS_OFFSET_Y })), jsxs(ApplyHomography, { x: x, y: y, h: h, children: [renderComponentsOnGroundPositions && (jsx("foreignObject", { x: "-1", y: "-1", width: "2", height: "2", children: renderComponentsOnGroundPositions({
                                player: {
                                    id: playerId,
                                },
                            }) })), jsx(GroundPosition, { colour: colour, id: `${playerId}`, onClick: (e) => onClickPlayer(e, playerId), onMouseEnter: (e) => onMouseEnterPlayer(e, playerId), onMouseLeave: (e) => onMouseLeavePlayer(e, playerId), testId: `${playerId}`, visibility: visibility })] })] }, `ground-position-${playerId}-${x}-${y}`));
    });
}

export { HighlightPlayerPositions as default };
//# sourceMappingURL=HighlightPlayerPositions.js.map
